const floorStatics = {
  p0_w: {
    sectionPath: '/floor_0',
    locationKey: 'p0_w',
    sectionKey: 'WOMAN',
    floorKey: '0',
    section: 'p0_w.section.name',
    floor: 'p0_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/301_P0.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/301_P0.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_w.path.floorMap.linkName',
        title: 'p0_w.path.floorMap.title',
        info: 'p0_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P0.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P0.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.floorMap.description.title',
          content: 'p0_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/lingerie',
        exact: true,
        location: 'lingerie',
        linkName: 'p0_w.path.lingerie.linkName',
        title: 'p0_w.path.lingerie.title',
        info: 'p0_w.path.lingerie.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P0_Lenceria_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P0_Lenceria.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.lingerie.description.title',
          content: 'p0_w.path.lingerie.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/shoes',
        exact: true,
        location: 'shoes',
        linkName: 'p0_w.path.shoes.linkName',
        title: 'p0_w.path.shoes.title',
        info: 'p0_w.path.shoes.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P0_CalzadoComplementos_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P0_CalzadoComplementos.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.shoes.description.title',
          content: 'p0_w.path.shoes.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/pickup',
        exact: true,
        location: 'pickup',
        linkName: 'p0_w.path.pickup.linkName',
        title: 'p0_w.path.pickup.title',
        info: 'p0_w.path.pickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P0_ReciclajeRopa_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P0_ReciclajeRopa.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.pickup.description.title',
          content: 'p0_w.path.pickup.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/onlinePickup',
        exact: true,
        location: 'onlinePickup',
        linkName: 'p0_w.path.onlinePickup.linkName',
        title: 'p0_w.path.onlinePickup.title',
        info: 'p0_w.path.onlinePickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P0_PuntoRecogidaOnline_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P0_PuntoRecogidaOnline.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.onlinePickup.description.title',
          content: 'p0_w.path.onlinePickup.description.content',
        },
      },
    ],
  },
  p1_w: {
    sectionPath: '/floor_1',
    locationKey: 'p1_w',
    sectionKey: 'WOMAN AND KIDS',
    floorKey: '1',
    section: 'p1_w.section.name',
    floor: 'p1_w.floor.name',
    title: 'Título de la Planta 1',
    img_banner:
      'https://static.zara.net/photos///2022/V/1/1/p/1381/910/001/2/w/649/1381910001_9_1_1.jpg?ts=1647001252352',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/301_P1.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_P1.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_1',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p1_w.path.floorMap.linkName',
        title: 'p1_w.path.floorMap.title',
        info: 'p1_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P1.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P1.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p1_w.path.floorMap.description.title',
          content: 'p1_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p1_w.path.fittingRooms.linkName',
        title: 'p1_w.path.fittingRooms.title',
        info: 'p1_w.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P1_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P1_TurnoProbadores.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.fittingRooms.description.title',
          content: 'p1_w.path.fittingRooms.description.content',
        },
      },
      {
        sectionPath: '/floor_1',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p1_w.path.selfCheckout.linkName',
        title: 'p1_w.path.selfCheckout.title',
        info: 'p1_w.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P1_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P1_Autocobro.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p1_w.path.selfCheckout.description.title',
          content: 'p1_w.path.selfCheckout.description.content',
        },
      },
    ],
  },
  p2_m: {
    sectionPath: '/floor_2',
    locationKey: 'p2_m',
    sectionKey: 'MAN',
    floorKey: '2',
    section: 'p2_m.section.name',
    floor: 'p2_m.floor.name',
    title: 'Título de la Planta 2',
    img_banner:
      'https://static.zara.net/photos///2022/V/0/2/p/0962/428/407/33/w/649/0962428407_15_1_1.jpg?ts=1646994080095',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/301_P2.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/14766_P2.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_2',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p2_m.path.floorMap.linkName',
        title: 'p2_m.path.floorMap.title',
        info: 'p2_m.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P2.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P2.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p2_m.path.floorMap.description.title',
          content: 'p2_m.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/athleticz',
        exact: true,
        location: 'athleticz',
        linkName: 'p2_m.path.athleticz.linkName',
        title: 'p2_m.path.athleticz.title',
        info: 'p2_m.path.athleticz.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P2_Athleticz_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P2_Athleticz.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_m.path.athleticz.description.title',
          content: 'p2_m.path.athleticz.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p2_m.path.fittingRooms.linkName',
        title: 'p2_m.path.fittingRooms.title',
        info: 'p2_m.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P2_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P2_TurnoProbadores.jpg?ts=1631201500000 ',

        description: {
          type: 'default',
          title: 'p2_m.path.fittingRooms.description.title',
          content: 'p2_m.path.fittingRooms.description.content',
        },
      },
      {
        sectionPath: '/floor_2',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p2_m.path.selfCheckout.linkName',
        title: 'p2_m.path.selfCheckout.title',
        info: 'p2_m.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P2_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/301_P2_Autocobro.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p2_m.path.selfCheckout.description.title',
          content: 'p2_m.path.selfCheckout.description.content',
        },
      },
    ],
  },
};

const StoreSuportedLanguages = [
  {
    language: 'pt-PT',
    name: 'Português',
  },
  {
    language: 'en-GB',
    name: 'English',
  },
];

const HomeStatics = {
  splash:
    'https://static.zara.net/photos/contents/multichannel/maps/ZARA_LONDRES___ONC_008.jpg?ts=1631201500000',
  prehome:
    'https://static.zara.net/photos/contents/multichannel/maps/301_ZARA_PORTO_IMG.jpg?ts=1631201500000',
  prehomeColor: '#fff',
};

const StoreConfig = {
  floorStatics,
  StoreSuportedLanguages,
  HomeStatics,
};

export default StoreConfig;
